import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import MuiIconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import styled from 'styled-components';

// Import all icons here
import MenuIcon from '@material-ui/icons/Menu';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import SearchIcon from '@material-ui/icons/Search';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import SettingsIcon from '@material-ui/icons/Settings';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import DashboardIcon from '@material-ui/icons/Dashboard';

interface IconProps extends Omit<SvgIconProps, 'color'> {
  Component: typeof SvgIcon;
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning'
    | 'error'
    | 'success'
    | 'default';
}

export const Icon = styled(({ Component, color, ...props }: IconProps) => (
  <Component {...props} />
))`
  &&& {
    color: ${({ theme, color }) => theme.palette.text[color ?? 'primary']};
  }
`;

const IconButton = (props: IconButtonProps) => (
  <MuiIconButton color="inherit" {...props} />
);

export {
  SvgIcon,
  IconButton,
  MenuIcon,
  ChevronRightIcon,
  ExpandMoreIcon,
  AccountBalanceWalletIcon,
  AccountBalanceIcon,
  SearchIcon,
  AddIcon,
  RemoveIcon,
  OpenInNewIcon,
  SettingsIcon,
  NotificationsIcon,
  NotificationsOffIcon,
  FlipCameraAndroidIcon,
  PhotoLibraryIcon,
  DashboardIcon,
};
